export interface IAlert {
    message?: string | null;
    value?: boolean;
    type?: string | null
}

export class Alert {
    public message!: string | null;
    public value!: boolean;
    public type!: string | null;


    constructor(alert: IAlert) {
        if (!alert) {
            throw new Error("Cannot construct from falsey IAlert");
        }
        this.message = alert.message || null;
        this.value = alert.value || false;
        this.type = alert.type || null;

    }

    public static generalError(): Alert {
        return new Alert({
            message: "Something went wrong while executing request",
            type: "error",
            value: true
        });
    }

    public static customError(msg: string): Alert {
        return new Alert({
            message: msg,
            type: "error",
            value: true
        });
    }

    public static massUploadError(): Alert {
        return new Alert({
            message: "Service Provider is currently in the process of uploading numbers. Try again later.",
            type: "warning",
            value: true
        });
    }

    public static success(message: string): Alert {
        
       return new Alert({
            message: message,
            type: "success",
            value: true
        });
    }

    public static warning(message: string): Alert {

        return new Alert({
            message: message,
            type: "warning",
            value: true,
        });
    }

    public static info(message: string): Alert {
        return new Alert({
            message: message,
            type: "info",
            value: true
        });
    }

    public static empty(): Alert {
        return new Alert({});
    }

 

    // public activate() {
    //
    //     this.$cookies.set('alert', this.alert);
    // }
    //
    // public deactivate() {
    //     this.$cookies.set("alert", Alert.empty());
    // }

}
